import { gql } from "@apollo/client";

export const DELETE_VOUCHER = gql`
	mutation ($ids: [ID!]!) {
		deleteVoucher(ids: $ids) {
			statusCode
		}
	}
`;

export const TOGGLE_VOUCHER_STATUS = gql`
	mutation ToggleVoucherStatus($ids: [ID!]!) {
		toggleVoucherStatus(ids: $ids) {
			statusCode
			message
			errors {
				field_name
				message
			}
		}
	}
`;

export const CREATE_VOUCHER = gql`
	mutation ($voucher: voucherInput!) {
		createVoucher(voucher: $voucher) {
			statusCode
			message
			errors {
				field_name
				message
			}
		}
	}
`;

export const UPDATE_VOUCHER = gql`
	mutation ($id: ID!, $voucher: updateVoucherInput!) {
		updateVoucher(id: $id, voucher: $voucher) {
			statusCode
			message
			errors {
				field_name
				message
			}
		}
	}
`;
